<template>
  <div>
    <!--v-show="show"-->
    <div align="right">
      <el-form :inline="true" class="style1">
        <el-form-item>
          <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">
            {{$t("general.add")}}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px" :empty-text="$t('general.empty_data')">

      <el-table-column :label="$t('general.date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.date }}</span>
        </template>
      </el-table-column>

      <el-table-column　:label="$t('companyInfo.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.comName }}</span>
        </template>
      </el-table-column>

      <el-table-column　label="被保険者数" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.people }}</span>
        </template>
      </el-table-column>

      <el-table-column　label="個人別票枚数" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sheet }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" width="360">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}
          </el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}
          </el-button>
          <el-button size="mini" type="success" icon="el-icon-view" @click="printPDF(scope.$index, scope.row)">
            {{ $t("general.print") }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- adding new -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      <el-form :model="inputForm" :rules="rules" ref="inputForm" label-width="11rem" class="demo-inputForm" size="medium" :label-position="labelPosition" style="width: 90%; margin-left: 5%; margin-right: 5%;">
        <el-input type="hidden" v-model="inputForm.id" />

        <el-form-item :label="$t('general.date')+':'" prop="date">
          <el-date-picker v-model="inputForm.date" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
          <el-select v-model="inputForm.company_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
            <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="資格取得年月日" prop="date">
          <el-date-picker v-model="inputForm.insStartDay" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('empIns4.genin_code')" prop="reason">
          <el-select v-model="inputForm.reason" :placeholder="$t('general.select')" size="mini" style="width: 100%;">
            <el-option v-for="item in genin" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('empIns4.employment_type_code')" prop="employmentType">
          <el-select v-model="inputForm.employmentType" :placeholder="$t('general.select')" clearable size="mini" style="width: 100%;">
            <el-option v-for="item in employment_type" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('empIns4.profession_type_code')" prop="professionType">
          <el-select v-model="inputForm.professionType" :placeholder="$t('general.select')" clearable size="mini" style="width: 100%;">
            <el-option v-for="item in profession_type" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label-width=2rem>
          <el-row>
            <el-col :md=12>
              <el-checkbox v-model="inputForm.contract" border>契約期間の定め</el-checkbox>
            </el-col>
            <el-col :md=12 v-if="inputForm.contract">
              <el-checkbox v-model="inputForm.contractUpdate" border>契約更新条項の有
              </el-checkbox>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="契約期間" prop="contractDate" v-if="inputForm.contract">
          <el-date-picker v-model="inputForm.contractStart" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%;">
          </el-date-picker>
          ～
          <el-date-picker v-model="inputForm.contractEnd" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%;">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="１週間の所定労働時間">
          <el-input-number v-model="inputForm.weekWorkHour" placeholder="00" style="width: 6rem;" size="mini" controls-position="right" :min="0" :max="168">
          </el-input-number>
          ：
          <el-input-number v-model="inputForm.weekWorkMin" placeholder="00" style="width: 6rem;" size="mini" controls-position="right" :min="0" :max="59" :step="15">
          </el-input-number>
        </el-form-item>

        <el-form-item label="届出被保険者数">
          <el-input-number v-model="inputForm.people" size="mini" style="width: 80%;" controls-position="right" :min="0"></el-input-number>&emsp;人
        </el-form-item>

        <el-form-item label="個人別票枚数">
          <el-input-number v-model="inputForm.sheet" size="mini" style="width: 80%;" controls-position="right" :min="0"></el-input-number> &emsp;枚
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="add('inputForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="cancel()" size="medium">
          {{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <!-- edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogEdit" width="35%" :before-close="handleClose">
      <el-form :model="inputForm" :rules="rules" ref="inputForm" label-width="11rem" class="demo-inputForm" size="medium" :label-position="labelPosition" style="width: 90%; margin-left: 5%; margin-right: 5%;">
        <el-input type="hidden" v-model="inputForm.id" />

        <el-form-item :label="$t('general.date')+':'" prop="date">
          <el-date-picker v-model="inputForm.date" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
          <el-select v-model="inputForm.company_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
            <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="資格取得年月日" prop="insStartDay">
          <el-date-picker v-model="inputForm.insStartDay" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('empIns4.genin_code')" prop="reason">
          <el-select v-model="inputForm.reason" :placeholder="$t('general.select')" size="mini" style="width: 100%;">
            <el-option v-for="item in genin" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('empIns4.employment_type_code')" prop="employmentType">
          <el-select v-model="inputForm.employmentType" :placeholder="$t('general.select')" clearable size="mini" style="width: 100%;">
            <el-option v-for="item in employment_type" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('empIns4.profession_type_code')" prop="professionType">
          <el-select v-model="inputForm.professionType" :placeholder="$t('general.select')" clearable size="mini" style="width: 100%;">
            <el-option v-for="item in profession_type" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label-width=2rem>
          <el-row>
            <el-col :md=12>
              <el-checkbox v-model="inputForm.contract" border>契約期間の定め</el-checkbox>
            </el-col>
            <el-col :md=12　v-if="inputForm.contract">
              <el-checkbox v-model="inputForm.contractUpdate" border>契約更新条項の有
              </el-checkbox>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="契約期間" prop="contractStart" v-if="inputForm.contract">
          <el-date-picker v-model="inputForm.contractStart" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%;">
          </el-date-picker>
          ～
          <el-date-picker v-model="inputForm.contractEnd" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 45%;">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="１週間の所定労働時間">
          <el-input-number v-model="inputForm.weekWorkHour" placeholder="00" style="width: 6rem;" size="mini" controls-position="right" :min="0" :max="168">
          </el-input-number>
          ：
          <el-input-number v-model="inputForm.weekWorkMin" placeholder="00" style="width: 6rem;" size="mini" controls-position="right" :min="0" :max="59" :step="15">
          </el-input-number>
        </el-form-item>

        <el-form-item label="届出被保険者数">
          <el-input-number v-model="inputForm.people" size="mini" style="width: 80%;" controls-position="right" :min="0"></el-input-number>&emsp;人
        </el-form-item>

        <el-form-item label="個人別票枚数">
          <el-input-number v-model="inputForm.sheet" size="mini" style="width: 80%;" controls-position="right" :min="0"></el-input-number> &emsp;枚
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="edit('inputForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="cancel()" size="medium">
          {{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <div style="text-align: left; margin-top: 50vh; font-size: smaller; width: fit-content; ">
      <el-row :gutter="40">
        <el-col :md=12>
          <el-card style="background-color: #51d1ff1c;">
            注意
            <ul>
              <li>
                この帳票は、「
                <el-link @click="jump('empIns3NewSubmission')">
                  雇用保険被保険者資格取得届（連記式）個人別票
                </el-link>
                」と合わせて使用すること。
              </li>
            </ul>
          </el-card>
        </el-col>
        <el-col :md=12>
          <el-card style="background-color: #51d1ff1c;">
            お願い
            <ol>
              <li>
                雇用保険の資格取得年月日の属する月の翌月10日までに提出してください。
              </li>
              <li>
                賃金台帳、労働者名簿、出勤簿その他記載内容を確認できる書類を持参していただく場合があります。
              </li>
            </ol>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      pageSize: 6,
      currentPage: 1,
      total: 0,
      disablePage: false,

      labelPosition: "left",

      dialogVisible: false,
      dialogEdit: false,

      tableData: [],
      companyInfo: [],

      inputForm: {
        id: "",
        company_id: "",
        insStartDay: "",
        reason: "",
        employmentType: "",
        professionType: "",
        contract: false,
        contractStart: "",
        contractEnd: "",
        contractUpdate: false,
        weekWorkHour: "",
        weekWorkMin: "",
        people: "",
        sheet: "",
        date: "",
      },

      rules: {
        company_id: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        date: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        insStartDay: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        contractStart: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },]
      },

      genin: [{
        value: "新規雇用（新規学卒）",
        label: this.$t("empIns4.new_graduate"),
      },
      {
        value: "新規雇用（その他）",
        label: this.$t("empIns4.new_other"),
      },
      {
        value: "日雇からの切替",
        label: this.$t("empIns4.from_daily"),
      },
      {
        value: "その他",
        label: this.$t("general.other"),
      },
      {
        value: "出向元への復帰等（65歳以上）",
        label: this.$t("empIns4.over60"),
      }
      ],

      employment_type: [{
        value: "日雇",
        label: this.$t("empIns4.daily"),
      },
      {
        value: "パートタイム",
        label: this.$t("empIns4.part_time"),
      },
      {
        value: "派遣",
        label: this.$t("empIns4.dispatch"),
      },
      {
        value: "有期契約労働者",
        label: this.$t("empIns4.contract_worker"),
      },
      {
        value: "季節的雇用",
        label: this.$t("empIns4.seasonal"),
      },
      {
        value: "船員",
        label: this.$t("empIns4.sailor"),
      },
      {
        value: "その他",
        label: this.$t("general.other"),
      }
      ],

      profession_type: [{
        value: "管理的職業",
        label: this.$t("empIns4.admin"),
      },
      {
        value: "専門的・技術的職業",
        label: this.$t("empIns4.technical"),
      },
      {
        value: "事務的職業",
        label: this.$t("empIns4.office"),
      },
      {
        value: "販売の職業",
        label: this.$t("empIns4.sale"),
      },
      {
        value: "サービスの職業",
        label: this.$t("empIns4.service"),
      },
      {
        value: "保安の職業",
        label: this.$t("empIns4.security"),
      },
      {
        value: "農林漁業の職業",
        label: this.$t("empIns4.agriculture"),
      },
      {
        value: "生産工程の職業",
        label: this.$t("empIns4.production"),
      },
      {
        value: "輸送・機械運転の職業",
        label: this.$t("empIns4.transportation"),
      },
      {
        value: "建設・採掘の職業",
        label: this.$t("empIns4.construction"),
      },
      {
        value: "運搬・清掃・包装等の職業",
        label: this.$t("empIns4.reacquire"),
      }
      ],
    };
  },
  methods: {
    preview(row) {
      var uid = window.localStorage.getItem('LoginUserId');
      window.open(
        "/pdf/雇用保険被保険者資格取得届（連記式）総括票-" + row.comName + row.date + row.people + "人" + row.sheet + "枚.pdf"
      );
    },
    printPDF(index, row) {
      let postData = this.qs.stringify({
        id: row.id
      });
      this.axios({
        method: "post",
        url: "/empIns3NewSummaryPDF",
        data: postData
      })
        .then((response) => {
          if (response.data.status = "success") {
            this.$message({
              type: "success",
              message: this.$t("general.print_completed")
            });
            setTimeout(() => {
              this.preview(row);
            }, 300);
          } else {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed")
            });
          }
        })
        .catch(error => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed")
          });
        });
    },


    add(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            company_id: this.inputForm.company_id,
            insStartDay: this.inputForm.insStartDay,
            reason: this.inputForm.reason,
            employmentType: this.inputForm.employmentType,
            professionType: this.inputForm.professionType,
            contract: this.inputForm.contract,
            contractStart: this.inputForm.contractStart,
            contractEnd: this.inputForm.contractEnd,
            contractUpdate: this.inputForm.contractUpdate,
            weekWorkHour: this.inputForm.weekWorkHour,
            weekWorkMin: this.inputForm.weekWorkMin,
            people: this.inputForm.people,
            sheet: this.inputForm.sheet,
            date: this.inputForm.date
          });
          this.axios({
            method: "post",
            url: "/insertEmpIns3NewSummary",
            data: postData
          })
            .then(response => {
              this.$message({
                type: "success",
                message: this.$t("general.add_completed")
              });
              this.currentPage = 1;
              this.getPages();
              this.dialogVisible = false;
              this.emptyForm();
            })
            .catch(error => {
              this.$message({
                type: "warning",
                message: this.$t("general.add_failed")
              });
              console.log(error);
            });
        } else {
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleEdit(index, row) {
      this.dialogEdit = true;
      this.inputForm = Object.assign({}, row);
    },

    edit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.inputForm.id,
            company_id: this.inputForm.company_id,
            insStartDay: this.inputForm.insStartDay,
            reason: this.inputForm.reason,
            employmentType: this.inputForm.employmentType,
            professionType: this.inputForm.professionType,
            contract: this.inputForm.contract,
            contractStart: this.inputForm.contractStart,
            contractEnd: this.inputForm.contractEnd,
            contractUpdate: this.inputForm.contractUpdate,
            weekWorkHour: this.inputForm.weekWorkHour,
            weekWorkMin: this.inputForm.weekWorkMin,
            people: this.inputForm.people,
            sheet: this.inputForm.sheet,
            date: this.inputForm.date
          });
          this.axios({
            method: "post",
            url: "/updateEmpIns3NewSummary",
            data: postData
          })
            .then(response => {
              this.handleCurrentChange();
              this.dialogEdit = false;
              this.emptyForm();
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed")
              });
              // console.log(response);
            })
            .catch(error => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed")
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleDelete(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id
          });
          this.axios({
            method: "post",
            url: "/deleteEmpIns3NewSummary",
            data: postData
          })
            .then(response => {
              this.getPages();
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed")
              });
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled")
          });
        });
    },

    jump(path) {
      this.$router.push(path);
    },

    cancel() {
      this.dialogVisible = false;
      this.dialogEdit = false;
      this.emptyForm();
    },

    emptyForm() {
      this.inputForm = {
        id: "",
        company_id: "",
        insStartDay: "",
        reason: "",
        employmentType: "",
        professionType: "",
        contract: false,
        contractStart: "",
        contractEnd: "",
        contractUpdate: false,
        weekWorkHour: "",
        weekWorkMin: "",
        people: "",
        sheet: "",
        date: "",
      }
      this.$refs['inputForm'].resetFields();
    },

    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(_ => {
          done();
          this.emptyForm();
        })
        .catch(_ => { });
    },

    handleCurrentChange() {
      let postData = this.qs.stringify({
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/pageEmpIns3NewSummary",
        data: postData
      })
        .then(response => {
          this.tableData = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getPages() {
      this.axios
        .post("/pageEmpIns3NewSummary")
        .then(response => {
          this.show = true
          this.tableData = response.data;
        })
        .catch(error => {
          this.show = false;
          //   this.$message({
          //     type: 'error',
          //     message: '開発中です。'
          //   });
          //   console.log(error);
        });
      this.axios
        .post("/rowsEmpIns3NewSummary")
        .then(response => {
          this.total = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
  },

  created() {
    this.getPages();

    //get Company List
    this.axios
      .post("/ListComInfo")
      .then((response) => {
        this.companyInfo = response.data;
        console.log(this.companyInfo);
      })
      .catch((error) => {
        console.log(error);
      });
  }
};
</script>

<style scoped>
.style1 {
  margin-right: 100px;
  padding: 0px;
  text-align: right;
}

.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpIns3NewSummary.vue